import React, { useState, useEffect, useContext } from "react";
import { dataContext, SERVER_HOST } from "../utils/constants";
import Header from "./Header";
import Sidebar from "./Sidebar";
import DatePicker from "./DatePicker";
import OrdersStatistics from "./dashboard-items/diOrdersStatistics";
import SalesReport from "./dashboard-items/diSalesReport";
import FiscalReport from "./dashboard-items/diFiscalReport";
import EfficiencyStatistics from "./dashboard-items/diEfficiencyStatistics";
import CashBalances from "./dashboard-items/diCashBalances";
import SuppliersDebt from "./dashboard-items/diSuppliersDebt";
import PaymentTypes from "./dashboard-items/diPaymentTypes";
import PeakHours from "./dashboard-items/diPeakHours";
import PopularMenu from "./dashboard-items/diPopularMenu";
import StopList from "./dashboard-items/diStopList";
// import LossSoldGoods from "./dashboard-items/diLossSoldGoods";

export default function Dashboard() {
    const [isDataUpdating, setDataUpdating] = useState(false);
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const [rangeStartDate, setRangeStartDate] = useState(lastMonth.toISOString().split("T")[0]);
    const [rangeEndDate, setRangeEndDate] = useState(today.toISOString().split("T")[0]);
    const [endDate, setEndDate] = useState(today.toISOString().split("T")[0]);

    const context = useContext(dataContext);
    const getSettings = context.getSettings;
    const setSettings = context.setSettings;
    const userRights = context.user.userRights;
    const isAdmin = context.user.isAdmin;

    const defaultItems = {
        // EndDate Statistics
        ordersStatistics: { show: true, label: "Статистика по замовленням" },
        cashBalances: { show: true, label: "Залишки коштів" },
        suppliersDebt: { show: true, label: "Борг постачальникам" },
        fiscalReport: { show: true, label: "Офіційні продажі" },
        paymentTypesDay: { show: true, label: "Види оплати (за день)" },
        stopList: { show: true, label: "Стоп-лист" },
        delimiter: { show: true, label: "---" },
        // Range Statistics
        salesReport: { show: true, label: "Статистика продажів" },
        efficiencyStatistics: { show: true, label: "Статистика ефективності" },
        paymentTypes: { show: true, label: "Види оплати" },
        peakHours: { show: true, label: "Пікові години" },
        popularMenu: { show: true, label: "Популярні страви" },
        // lossSoldGoods: { show: true, label: "Продажі в збиток" },
    };

    const [visibleItems, setVisibleItems] = useState(() => {
        const userSettings = getSettings();
        const storedItems = userSettings.shef ? userSettings.shef.dashboardVisibleItems : null;
        return storedItems ? storedItems : defaultItems;
    });

    useEffect(() => {
        const userSettings = getSettings();
        setSettings({
            ...userSettings,
            shef: { ...userSettings.shef, dashboardVisibleItems: visibleItems },
        });
        // eslint-disable-next-line
    }, [visibleItems]);

    useEffect(() => {
        setDataUpdating(false);
    }, [isDataUpdating]);

    const handleDataUpdate = () => {
        setSidebarOpen(false);
        setDataUpdating(true);
    };

    const handleLogout = async () => {
        try {
            await fetch(SERVER_HOST, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ action: "logout" }),
            });
            window.location.reload();
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    return (
        <>
            <Header toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onLogout={handleLogout}
                visibleItems={visibleItems}
                setVisibleItems={setVisibleItems}
                handleDataUpdate={handleDataUpdate}
                userRights={userRights}
                isAdmin={isAdmin}
            />
            {!isDataUpdating && (
                <div className="container dashboard--container pb-2">
                    <div className="row d-flex justify-content-around">
                        <div className="col col-12 col-md-11 col-lg-9 col-xl-8 col-xxl-7 row justify-content-center m-0 p-0">
                            <div style={{ marginTop: "40px" }}></div>

                            {/* EndDate Statistics */}
                            {(visibleItems.ordersStatistics.show ||
                                visibleItems.cashBalances.show ||
                                visibleItems.suppliersDebt.show ||
                                visibleItems.paymentTypesDay.show) && (
                                <div className="col-12 dashboard--item">
                                    <div className="dashboard--item--container p-3 d-flex justify-content-center">
                                        <div className="col-auto d-flex mt-1">
                                            <label className="me-1 align-self-center fw-bold fs-5">
                                                Статистика за:
                                            </label>
                                            <input
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                className="form-control-sm bg-secondary border-0 text-white rounded-5"
                                                style={{
                                                    WebkitTextFillColor: "white",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {(isAdmin === 1 || userRights.urOrdersStatistics === 1) &&
                                visibleItems.ordersStatistics.show && <OrdersStatistics endDate={endDate} />}
                            {(isAdmin === 1 || userRights.urCashBalances === 1) && visibleItems.cashBalances.show && (
                                <CashBalances endDate={endDate} />
                            )}
                            {(isAdmin === 1 || userRights.urSuppliersDebt === 1) && visibleItems.suppliersDebt.show && (
                                <SuppliersDebt endDate={endDate} />
                            )}
                            {(isAdmin === 1 || userRights.urPaymentTypes === 1) &&
                                visibleItems.paymentTypesDay.show && <PaymentTypes endDate={endDate} />}
                            {(isAdmin === 1 || userRights.urFiscalReport === 1) && visibleItems.fiscalReport.show && (
                                <FiscalReport />
                            )}
                            {(isAdmin === 1 || userRights.urStopList === 1) && visibleItems.stopList.show && (
                                <StopList />
                            )}

                            {/* Range Statistics */}
                            {(visibleItems.salesReport.show ||
                                visibleItems.efficiencyStatistics.show ||
                                visibleItems.paymentTypes.show ||
                                visibleItems.peakHours.show ||
                                // visibleItems.lossSoldGoods.show ||
                                visibleItems.popularMenu.show) && (
                                <div className="col-12 dashboard--item">
                                    <div className="dashboard--item--container p-3">
                                        <DatePicker
                                            startDate={rangeStartDate}
                                            endDate={rangeEndDate}
                                            onStartDateChange={setRangeStartDate}
                                            onEndDateChange={setRangeEndDate}
                                        />
                                    </div>
                                </div>
                            )}
                            {(isAdmin === 1 || userRights.urSalesReport === 1) && visibleItems.salesReport.show && (
                                <SalesReport startDate={rangeStartDate} endDate={rangeEndDate} />
                            )}
                            {(isAdmin === 1 || userRights.urEfficiencyStatistics === 1) &&
                                visibleItems.efficiencyStatistics.show && (
                                    <EfficiencyStatistics startDate={rangeStartDate} endDate={rangeEndDate} />
                                )}

                            {(isAdmin === 1 || userRights.urPaymentTypes === 1) && visibleItems.paymentTypes.show && (
                                <PaymentTypes startDate={rangeStartDate} endDate={rangeEndDate} />
                            )}
                            {(isAdmin === 1 || userRights.urPeakHours === 1) && visibleItems.peakHours.show && (
                                <PeakHours startDate={rangeStartDate} endDate={rangeEndDate} />
                            )}
                            {(isAdmin === 1 || userRights.urPopularMenu === 1) && visibleItems.popularMenu.show && (
                                <PopularMenu startDate={rangeStartDate} endDate={rangeEndDate} />
                            )}

                            {/* {(isAdmin === 1 ||
                                userRights.urLossSoldGoods === 1) &&
                                visibleItems.lossSoldGoods.show && (
                                    <LossSoldGoods
                                        startDate={startDate}
                                        endDate={endDate}
                                    />
                                )} */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
